import { inject, Pipe, PipeTransform } from '@angular/core';
import { LocalizeService } from '../localize.service';
import { LocaleString } from '../../translate/localeString.model';

@Pipe({
    name: 'localize',
    pure: false,
    standalone: true
})
export class LocalizePipe implements PipeTransform {

    private localizeService = inject(LocalizeService);

    transform(value: LocaleString | string): string {
        return this.localizeService.transform(value);
    }

}
